import type { FirebaseOptions } from 'firebase/app'
import { initializeApp } from 'firebase/app'
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check'
import {
    browserLocalPersistence,
    browserPopupRedirectResolver,
    indexedDBLocalPersistence,
    initializeAuth,
} from 'firebase/auth'
import { initializeFirestore } from 'firebase/firestore'
import { getAnalytics, logEvent } from 'firebase/analytics'
import LogRocket from 'logrocket'

const firebaseConfig: FirebaseOptions = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: 'throw-log',
    storageBucket: 'throw-log.appspot.com',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
}
declare global {
    interface Window {
        FIREBASE_APPCHECK_DEBUG_TOKEN: boolean
    }
}

export const initFirebase = () => {
    if (import.meta.env.DEV) {
        window.FIREBASE_APPCHECK_DEBUG_TOKEN = true
    }

    if (typeof document !== 'undefined') {
        const app = initializeApp(firebaseConfig)

        initializeAppCheck(app, {
            provider: new ReCaptchaEnterpriseProvider('6LcDnBEoAAAAAHiFPwHOWHVVzMVEKcGKWZH38Huf'),
            isTokenAutoRefreshEnabled: true,
        })

        const auth = initializeAuth(app, {
            popupRedirectResolver: browserPopupRedirectResolver,
            persistence: [browserLocalPersistence, indexedDBLocalPersistence],
        })

        auth.useDeviceLanguage()

        initializeFirestore(app, {
            ignoreUndefinedProperties: true,
        })

        window.addEventListener('error', function (evt) {
            logEvent(getAnalytics(app), 'browser_uncaught_error', {
                error: JSON.stringify(evt),
                client: 'td-web',
            })
            LogRocket.error('Uncaught error', evt)
        })

        window.addEventListener('unhandledrejection', event => {
            logEvent(getAnalytics(app), 'browser_ignored_error', {
                error: event.reason,
                client: 'td-web',
            })
            LogRocket.error('Unhandled promise rejection', event)
        })
    }
}
